// extracted by mini-css-extract-plugin
export default {"container":"tournamentComments_container__FOAOg","linksWrapper":"tournamentComments_linksWrapper__u2t7k","linkWrapper":"tournamentComments_linkWrapper__67PTf"};